import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initTrace } from './game/trace';
import './index.css';

// TURN-INTENT TRACE: capture-build only. `TRACE_BUILD` is a build-time
// constant -- Vite statically replaces `import.meta.env.VITE_ENABLE_TRACE`
// at build time, so in every plain/prod build (the flag unset) this folds
// to `if (false) { ... }` and the bundler dead-code-eliminates the whole
// branch, dropping the `initTrace` import along with it (see game/trace.ts's
// module doc comment, DEPLOY.md, and scripts/play-trace.mjs which sets
// VITE_ENABLE_TRACE=1 for the LAN capture launcher). When it IS set to '1'
// this reads `?debug=joystick` once at boot exactly as before -- a no-op
// (queryEnabled stays false, nothing else changes) for every session that
// doesn't pass it; the Settings toggle half of the opt-in needs no call
// here (read live).
const TRACE_BUILD = import.meta.env.VITE_ENABLE_TRACE === '1';
if (TRACE_BUILD) {
  initTrace();
}

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('#root element missing from index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
